import { RootState } from '../store';

export const selectCountryOptions = (state: RootState) => state.country.countryOptions;

export const selectCountryOptionsRequestStatus = (state: RootState) => state.country.countryOptionsRequestStatus;
